import { createAction, createSlice, PayloadAction } from '@reduxjs/toolkit';

import { SubmodalId } from '../constants';
import { CloseSettingsSubmodalCloseOptions } from '../types';
import { ActiveSettingsSectionKeyType, OpenSettingsModalPayload, SettingsModalState } from './types';

const initialState: SettingsModalState = {
    isOpened: false,
    isHiddenSectionVisible: false,
    activeSectionKey: null,
    submodalId: null,
};

const settingsModalSlice = createSlice({
    name: 'settingsModal',
    initialState,
    reducers: {
        setIsOpened(state: SettingsModalState, action: PayloadAction<boolean>) {
            state.isOpened = action.payload;
        },
        setSettingsSubmodalId(state: SettingsModalState, action: PayloadAction<SubmodalId>) {
            state.submodalId = action.payload;
        },
        closeSettingsSubmodal(state: SettingsModalState) {
            state.submodalId = null;
        },
        closeSettingsModal(state: SettingsModalState) {
            state.isOpened = false;
        },
        setIsHiddenSectionVisible(state: SettingsModalState, action: PayloadAction<Maybe<boolean>>) {
            state.isHiddenSectionVisible = action.payload;
        },
        setActiveSectionKey(state: SettingsModalState, action: PayloadAction<ActiveSettingsSectionKeyType>) {
            state.activeSectionKey = action.payload;
        },
    },
});

export const {
    setIsOpened,
    setIsHiddenSectionVisible,
    setActiveSectionKey,
    closeSettingsModal,
    setSettingsSubmodalId,
    closeSettingsSubmodal,
} = settingsModalSlice.actions;

export const openSettingsModalAction = createAction<Maybe<OpenSettingsModalPayload>>('@settingsModal/open');
export const changeActiveSectionAction = createAction<ActiveSettingsSectionKeyType>(
    '@settingsModal/changeActiveSection'
);
export const closeSettingsSubmodalAction = createAction<CloseSettingsSubmodalCloseOptions>(
    '@settingsModal/closeSettingsSubmodalAction'
);

export const resetSettingsPermissionsExtendedAction = createAction(
    '@settingsModal/resetSettingsPermissionsExtendedAction'
);
export const returnToDefaultSettingsPermissionsExtendedAction = createAction(
    '@settingsModal/returnToDefaultSettingsPermissionsExtendedAction'
);
export const applySettingsPermissionsExtendedAction = createAction(
    '@settingsModal/applySettingsPermissionsExtendedAction'
);

export const settingsModalReducer = settingsModalSlice.reducer;
